import React, { Context, createContext, useReducer } from 'react';
import {
  ToastContextProps,
  ToastContext,
  ToastAction,
  ToastState,
  ToastActionType,
  ToastProps,
} from './Toast.types';
import { uuid } from '../../util/string.util';
import { BreadBag, Toast } from './components';
import { toast } from './Toast.actions';

export const Toaster = createContext(
  {} as ToastContext,
) as Context<ToastContext>;

const initialState: ToastState = { toasts: [] };

type Reducer = (state: ToastState, action: ToastAction) => ToastState;

const storeReducer: Reducer = (state, action) => {
  const newState = state;

  switch (action.type) {
    case ToastActionType.ADD_TOAST:
      const payload = { ...(action.payload as ToastProps) };
      let content = payload.content;

      // handle error formats from core api
      if (typeof content === 'object') {
        if ((content as any).message) {
          content = (content as any).message;
        } else {
          content = Object.values(content!).join('\n');
        }
      }

      payload.content = content;
      payload.id = payload.id || uuid();

      return { ...state, toasts: [...state.toasts, payload] };
    case ToastActionType.REMOVE_TOAST:
      const id = action.payload as string;
      const toasts = state.toasts.filter(t => t.id !== id);
      return { ...state, toasts };
    default:
      break;
  }

  return newState;
};

// i am the provider of the toast
export const ToastProvider = (props: ToastContextProps) => {
  const [state, dispatch] = useReducer(storeReducer, initialState);

  const localContext: ToastContext = {
    state,
    dispatch,
    toast,
    toaster: dispatch,
  };

  return (
    <Toaster.Provider value={localContext}>
      <BreadBag>
        {state.toasts.map(props => (
          <Toast key={props.id} {...props} />
        ))}
      </BreadBag>
      {props.children}
    </Toaster.Provider>
  );
};
